import { createStore } from 'vuex'
import router from '../router'
import axios from 'axios'
import config from '../config'

export default createStore({
  state: {
    user: undefined,
  },
  getters: {
    hasToken: () => {
        if (localStorage.getItem(config.token_name) === null) return undefined
        return localStorage.getItem(config.token_name)
    },
  },
  mutations: {
    setUser (state, user) {
        state.user = user
    },
    clearUser (state) {
        localStorage.removeItem(config.token_name)
        state.user = undefined
        router.push({ name: 'Login' })
    }
  },
  actions: {
    getUser ({ commit }) {
      if (localStorage.getItem(config.token_name) === null){
            return commit('clearUser')
      }
      return axios
              .get(config.getme_url, {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem(config.token_name)
                    }
              })
              .then((res) => {
                    res = res.data
                    if (res.status === 200) {
                        commit('setUser', res.data.user)
                        return true
                    } 
                    else if (res.status !== 200) {
                        commit('clearUser')
                    }
              })
              .catch(() => {
                // return commit('clearUser')
              })
    },
    loginUser ({ commit }, user) {
        return new Promise((resolve, reject) => {
                axios
                    .post(config.login_url, {
                        phone: user.phone,
                        password: user.password
                    })
                    .then((res) => {
                        res = res.data
                        if (res.status === 200) {
                            commit('setUser', res.data.user)
                            localStorage.setItem(config.token_name, res.data.at)
                            
                            router.push({ name: 'Home' })
                            resolve('Пользователь найден')
                        } else {
                            reject('Пользователь не найден')
                        }
                    })
                    .catch(() => {
                        // reject(error.message)
                        reject('Пользователь не найден')
                    })
            })
        // });
    },
    logoutUser ({ commit }) {
        axios
            .get(config.logout_url, {
                headers: {
                    Authorization: 'Bearer ' + this.getters.hasToken
                }
            })
            .finally(() => {
                commit('clearUser')
            })
    },
    registerUser ({ commit }, user) {
        // axios.get('/sanctum/csrf-cookie').then(response => {
        return new Promise((resolve, reject) => {
                axios
                    .post(config.register_url, user)
                    .then((res) => {
                        res = res.data
                        if (res.status === 200) {
                            commit('setUser', res.data.user)
                            localStorage.setItem(config.token_name, res.data.at)
                            
                            if (res.data.user?.role == 'transporter'){
                                router.push({ name: 'TransporterOffersActive' })
                            } else {
                                router.push({ name: 'PassengerOffersActive' })
                            }
                            resolve('Пользователь найден')
                        } else {
                            reject('Пользователь не найден')
                        }
                    })
                    .catch((errors) => {
                        const server_errors = ['Регистрация не удалась']
                        Object.values(errors.response?.data?.errors).map((se) => se.map((item) => server_errors.push(item)))
                        reject(server_errors)
                    })
            })
        // });
    },
  },
  modules: {
  }
})
